// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__D_k4E","title":"styles_title__3Tkpr","input":"styles_input__Qo_yA","tags":"styles_tags__3Mi2p","newTag":"styles_newTag__330H8"};